import React from "react";
import PropTypes from "prop-types";
import NarrativeTokenField from "../NarrativeTokenField";

/**
 * SummaryField - a labeled prose editor for ONE of the report's per-page summaries
 * (overview_summary/performance_summary/drivers_summary/forecast_summary), backed by
 * NarrativeTokenField so an author can @-mention a live figure inline (see
 * NarrativeTokenField.jsx for the token-string contract). Extracted from NarrativeRail
 * (SP6 Task 5) so NarrativeRail and BoardReportInspector render a page summary identically -
 * the caller supplies `label` (also the field's accessible name, via NarrativeTokenField's
 * `ariaLabel`) and which summary this instance edits is entirely the caller's concern (this
 * component just edits whatever token string it's given).
 */
const SummaryField = ({ label, value, onChange, disabled, metrics, catalog, onFocus }) => (
  <div className="block">
    <span className="block text-xs font-medium text-text-2 mb-1">{label}</span>
    <NarrativeTokenField
      value={value || ""}
      onChange={onChange}
      metrics={metrics}
      catalog={catalog}
      disabled={disabled}
      ariaLabel={label}
      onFocus={onFocus}
    />
  </div>
);

SummaryField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  metrics: PropTypes.object,
  catalog: PropTypes.array,
  onFocus: PropTypes.func,
};

export default SummaryField;
